
import Header from "./Components/Header";
import Footer from "./Components/Footer";

function Layout(props) {
    return (
        <>
            <Header />

              {props.children}

            <Footer />
        </>
    );
}

export default Layout;